import { getFlagConfigScheduledChanges } from '@gonfalon/openapi/operations/getFlagConfigScheduledChanges';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getFlagConfigScheduledChangesQuery = createQueryOptions(getFlagConfigScheduledChanges);
